export const zh = {
    Global: {
      save: '保存',
      savingInProgress: 'Saving in progress ZH',
      edit: '编辑',
      amend: 'Amend ZH',
      editProposal: 'Edit proposal ZH',
      delete: '删除',
      cancel: '取消',
      confirm: '确认',
      proceed: '继续',
      assign: '指派',
      submit: '提交',
      accepted: '接保',
      denied: '拒保',
      deny: '拒绝',
      done: '完成',
      notDone: '尚未完成',
      started: '已开始',
      notRelevant: '不相关',
      noInfo: '无信息',
      addComment: '添加评论',
      noComments: '没有评论',
      comment: '评论',
      start: '起始日期',
      end: '结束日期',
      pending: '待定',
      approve: '批准',
      approved: '已批准',
      notApproved: '未批准',
      release: '释放',
      released: '已释放',
      notReleased: '未释放',
      reopen: '重新打开',
      requestedBy: '申请人',
      requestedAt: '申请日期',
      proposedDecision: '保修判定建议',
      proposedCategory: '保修类别',
      proposedSubcategory: 'Proposed subcategory',
      search: '搜索',
      noResults: '没有结果',
      upload: '上传',
      uploading: '上传中',
      noFilesUploaded: '没有上传文件',
      close: '关闭',
      back: '返回',
      next: '下一个',
      unknown: '未知',
      from: '从',
      to: '至',
      logout: '退出',
      profile: '用户数据',
      group: '组',
      code: '代码',
      confirmationDialogTitle: '需要确认',
      confirmDeleteFileDialogContent: '你确定要删除这个文件吗？',
      report: '报告',
      unsavedAnswers: '您有尚未保存的数据。如果确认，您将丢失所有未保存的数据。',
      unsavedAnswersActionMode: '您尚未保存答案。 您要保存吗？',
      noOptions: '没有选项',
      actionMode: '移动模式',
      reason: '理由',
      optional: '可选',
      choose: '选择',
      serialNumberMissing: 'Serial number missing ZH',
      recipientEmails: 'Recipient Emails (one address per line) ZH',
      DatePicker: {
        cancelLabel: '取消',
        okLabel: '确认',
        minDateMessage: '请输入1900年之后的日期',
        maxDateMessage: '日期不应是未来日期',
        invalidDateMessage: '日期格式无效',
      },
      Errors: {
        authErrorTitle: '授权错误',
        authErrorParagraph1: '您无权访问此应用',
        authErrorParagraph2: '请联系您的管理员',
        authErrorParagraph3: '或者退出活动目录，然后再试一次。',
        pageNotFound: '网页未找到',
        pageNotFoundParagraph1: '我们无法找到该网页',
        back: '主页',
        rotateDevice: '请旋转您的设备。',
      },
      Feedback: {
        error: '发生错误，操作失败。',
        authentication: '正在验证...请稍候',
        success: '操作成功完成',
        limitReached: '超过商务判定审批限额',
        requestHasBeenSentToApprover: '请求已发送给审批者',
        noQuestions: '所选产品系列无相关问题。',
        decisionNotSend: '判定没有成功发送到SAP',
        noLimitForCC: '您尚未为该客户中心设置商务审批限额。',
        jobCostDoesNotExist:'工单价格来自SAP，工单在PARS数据库中不存在。',
        materialNumberBrandDoesNotExist: '该物料号品牌不存在',
        jobIsLocked: '工单被锁定',
        noPicturesAreUploaded: '没有照片上传',
        rateIsProvided: '评价已成功登记',
        rateHasToBeDifferent: '判定评价必须与之前的不同',
      },
      Status: {
        title: '状态',
        awaitingEquipment: '等待设备',
        equipmentReceivedWithDocumentation: '接收设备与文档',
        jobReleased: '工单释放',
        productEvaluation: '设备评估',
        strippedAndDecontaminated: '拆解和清洗',
        builtAndTested: '组装和测试',
        shipped: '发货',
        technicalAndCommercialDecision: '技术和商务判定',
        finalReportReleased: '最终报告发布',
        closed: '关闭',
        productInvestigation: '产品调查',
        customerHold: '有待客户确认',
        notStarted: '未开始',
      },
      Roles: {
        RECEIVING: '收货人',
        SERVICE_ENGINEER: '维修工程师',
        FAILURE_ANALYSIS_ENGINEER: '故障分析工程师',
        SENIOR_FAILURE_ANALYSIS_ENGINEER: '资深故障分析工程师',
        FAILURE_ANALYSIS_MANAGER: '故障分析经理',
        SERVICE_TECHNOLOGY_CENTER_MANAGER: 'STC经理',
        QUALITY_MANAGER: '质量经理',
        SERVICE_TECHNICAL_SUPPORT_TEAM: '服务技术支持团队',
        PRODUCT_COMPANY_TECHNICAL_SUPPORT_TEAM: 'PC技术支持团队',
        DIVISION_OR_BUSINESS_AREA: '事业部',
        CUSTOMER_CENTER: '客户中心',
        CUSTOMER: '客户',
        CUSTOMER_CENTER_SERVICE_ENGINEER: '客户中心服务工程师',
        SENIOR_CUSTOMER_CENTER_SERVICE_ENGINEER: 'Senior customer center service engineer ZH',
        SUPERADMIN: '超级管理员',
        ZONE_LEADER: '区域组长',
        QUESTION_ADMIN: '问题管理员',
        DISTRIBUTOR: '发行人',
      },
      Permissions: {
        VIEW_JOB: '查看工单',
        EDIT_JOB: '编辑工单',
        IMPORT_JOB_FROM_SAP: '从SAP导入工单',
        LEVEL_3_RELEASE_FOR_INVESTIGATION: '发布3级分析诊断作业',
        LEVEL_4_RELEASE_FOR_INVESTIGATION: '发布4级分析诊断作业',
        GENERATE_AND_DOWNLOAD_REPORT: '生成并下载报告',
        VIEW_LOG: '查看日志',
        VIEW_CONVERSATION: '查看对话',
        PARTICIPATE_IN_CONVERSATION: '参与对话',
        TAG_INTEREST: '标签',
        ADD_REMOVE_FROM_TEAM: '添加和删​​除团队成员',
        CREATE_JOB: '创建工单',
        DELETE_JOB: '删除工单',
        REQUEST_DIFFERENT_REPORT_LEVEL: '申请不同报告等级',
        APPROVE_DIFFERENT_REPORT_LEVEL: '审批报告等级变更',
        WARRANTY_DECISION: '保修判定',
        GOODWILL_DECISION: '商务判定',
        LEVEL_1_REPORT_APPROVAL: '1级报告审批',
        LEVEL_2_REPORT_APPROVAL: '2级报告审批',
        LEVEL_3_REPORT_APPROVAL: '3级报告审批',
        LEVEL_4_REPORT_APPROVAL: '4级报告审批',
        LEVEL_1_REPORT_REOPEN: 'Level 1 report reopen ZH',
        LEVEL_2_REPORT_REOPEN: 'Level 2 report reopen ZH',
        LEVEL_3_REPORT_REOPEN: 'Level 3 report reopen ZH',
        LEVEL_4_REPORT_REOPEN: 'Level 4 report reopen ZH',
        REOPEN_REPORT: '重新打开报告',
        REQUEST_FAILED_PARTS: '请求故障零件',
        SHIP_FAILED_PARTS: '发送故障零件',
        PRINT_INPUT_SHEETS: '打印输入表',
        ADMINISTRATE_QUESTIONS: '管理问题',
        ADMINISTRATE_DATA: '管理数据',
        DOWNLOAD_PICTURES: 'Download pictures ZH',
        REQUEST_TECHNICAL_WARRANTY_DECISION: 'Request technical warranty decission ZH',
        AMEND_APPROVED_TECHNICAL_DECISION: 'Amend approved technical decision ZH',
        AMEND_APPROVED_COMMERCIAL_DECISION: 'Amend approved commercial decision ZH',
        ADD_INITIAL_WARRANTY_CODE: 'Add initial warranty code ZH',
        RECLASSIFY_TECHNICAL_WARRANTY_CATEGORY: 'Reclassify technical warranty category ZH',
        APPROVE_REPORT_LEVEL_4_DOWNGRADE: 'Approve report level 4 downgrade ZH',
      },
      Alerts: {
        noAlerts: '无提醒',
        healthAndSafetyInformationMissing: '无健康和安全信息',
        jobNotReleased: '工单未发布',
        noRecentStatusChange: '最近状态无变更',
        noServiceTechnicalSupportInvolvement: '无需技术支持工程师参与',
        noProductCompanyTechnicalSupportInvolvement: '尚未指派产品技术支持工程师',
        noTechnicalWarrantyDecision: '无保修判定',
        noCommercialDecision: '无商务判定',
        reportNotApproved: '报告尚未审批',
      },
      Actions: {
        ADD_JOB: '新增工单',
        IMPORT_JOB: '从SAP导入工单',
        DELETE_JOB: '删除工单',
        VERIFY_JOB: '核实信息',
        SET_PRICE: '编辑工单 - 价格',
        ADD_TEAM_MEMBER: '添加团队成员',
        REMOVE_TEAM_MEMBER: '删除团队成员',
        REQUEST_REPORT_LEVEL_CHANGE: '报告等级变更请求',
        APPROVE_REPORT_LEVEL_CHANGE: '报告等级变更审批通过',
        DENY_REPORT_LEVEL_CHANGE: '报告等级变更审批未通过',
        REQUEST_REPORT_APPROVAL: '报告审批已申请',
        APPROVE_REPORT_APPROVAL: '报告审批已通过',
        DENY_REPORT_APPROVAL: '报告审批未通过',
        SET_WARRANTY_START_DATE: '编辑 - 保修起始日期',
        SET_WARRANTY_END_DATE: '编辑 - 保修截止日期',
        EQUIPMENT_SERIAL_NUMBER_EDITED: '编辑 - 设备序列号',
        MATERIAL_NUMBER_EDITED: '编辑 - 料号',
        WORKED_ON_JOB: '编辑 - 更新表格',
        UPLOADED_FILE_ON_JOB: '编辑 - 上传文件',
        REQUEST_TECHNICAL_WARRANTY_DECISION: '保修判定请求',
        APPROVE_TECHNICAL_WARRANTY_DECISION: '技术保修判定已批准',
        DENY_TECHNICAL_WARRANTY_DECISION: '技术保修判定已否决',
        REQUEST_COMMERCIAL_WARRANTY_DECISION: 'Requested commercial warranty decision',
        APPROVE_COMMERCIAL_WARRANTY_DECISION: '商务判定已批准',
        NULLIFY_COMMERCIAL_WARRANTY_DECISION: '无效的商务决定',
        DENY_COMMERCIAL_WARRANTY_DECISION: '被拒绝的商业保修决定',
        SEND_COMMENT: '添加评论',
        REOPEN_REPORT: '编辑工单- 重新打开工单',
        AWAITING_EQUIPMENT_STATUS_SET: '编辑状态 - 等待设备 - 状态已设定',
        AWAITING_EQUIPMENT_STATUS_RESET: '编辑状态 - 等待设备 - 状态重置',
        EQUIPMENT_RECEIVED_WITH_DOCUMENTATION_STATUS_SET: '编辑状态 - 设备接受 - 状态已设定',
        EQUIPMENT_RECEIVED_WITH_DOCUMENTATION_STATUS_RESET: '编辑状态 - 设备接受 - 状态重置',
        JOB_RELEASED_STATUS_SET: '编辑状态 - 发布工单 - 状态已设定',
        JOB_RELEASED_STATUS_RESET: '编辑状态 - 发布工单 - 状态重置',
        PRODUCT_EVALUATION_STATUS_SET: '编辑状态 - 产品评估 - 状态已设定',
        PRODUCT_EVALUATION_STATUS_RESET: '编辑状态 - 产品评估 - 状态重置',
        PRODUCT_INVESTIGATION_STATUS_SET: '编辑状态 - 产品调查 - 状态已设定',
        PRODUCT_INVESTIGATION_STATUS_RESET: '编辑状态 - 产品调查 - 状态重置',
        STRIPPED_AND_DECONTAMINATED_STATUS_SET: '编辑状态 - 拆解及去污 - 状态已设定',
        STRIPPED_AND_DECONTAMINATED_STATUS_RESET: '编辑状态 - 拆解及去污 - 状态重置',
        BUILT_AND_TESTED_STATUS_SET: '编辑状态 - 组装及测试 - 状态已设定',
        BUILT_AND_TESTED_STATUS_RESET: '编辑状态 - 组装及测试 - 状态重置',
        SHIPPED_STATUS_SET: '编辑状态 - 发货 - 状态已设定',
        SHIPPED_STATUS_RESET: '编辑状态 - 发货 - 状态重置',
        TECHNICAL_AND_COMERCIAL_DECISION_STATUS_SET: '编辑状态 - 技术和商务判定 - 状态已设定',
        TECHNICAL_AND_COMERCIAL_DECISION_STATUS_RESET: '编辑状态 - 技术和商务判定 - 状态重置',
        FINAL_REPORT_RELEASED_STATUS_SET: '编辑状态 - 发布最终报告 - 状态已设定',
        FINAL_REPORT_RELEASED_STATUS_RESET: '编辑状态 - 发布最终报告 - 状态重置',
        CLOSED_STATUS_SET: '编辑状态 - 关闭 - 状态已设定',
        CLOSED_STATUS_RESET: '编辑状态 - 关闭 - 状态重置',
        CUSTOMER_HOLD_STATUS_SET: '编辑状态 - 客户保留 - 状态已设定',
        CUSTOMER_HOLD_STATUS_RESET: '编辑状态 - 客户保留 - 状态重置',
        REFACTOR_TECHNICAL_WARRANTY_DECISION: '编辑保修判定类别',
        GENERATE_ALERT: '产生提醒',
        INITIAL_WARRANTY_CODE_EDITED: '初始保修代码已更改',
        AMEND_APPROVED_TECHNICAL_DECISION: 'Amended approved technical warranty decision ZH',
        AMEND_APPROVED_COMMERCIAL_DECISION: 'Amended approved commercial decision ZH',
        DELETE_APPROVED_TECHNICAL_DECISION: 'Deleted aproved technical warranty decision ZH',
        DELETE_APPROVED_COMMERCIAL_DECISION: 'Deleted approved commercial decision ZH',
        CHOOSE_RELEASE_METHOD: 'Chose release method ZH',
      },
      TechnicalWarranty: {
        ACCEPTED: '接保',
        DENIED: '拒保',
        AGREE: '同意',
        DISAGREE: '不同意',
        MANUFACTURING: '制造',
        DESIGN: '产品设计',
        VENDOR: '供应商',
        PROCESS: '制程',
        INHOUSE_REPAIR: '车间维修',
        FIELD_SERVICE_REPAIR: '现场维修',
        NO_FAULT_FOUND: '无缺陷',
        WARRANTY_EXPIRED: '保修期满',
        WARRANTY_EXPIRED_NO_FAULT_FOUND: 'Out of standard warranty period - No fault found',
        WARRANTY_EXPIRED_CUSTOMER_FAULT: 'Out of standard warranty period - Customer fault',
        WARRANTY_EXPIRED_OTHER: 'Out of standard warranty period - Other',
        WARRANTY_EXPIRED_COMPONENT_ISSUE: 'Out of standard warranty period - Component issue (Edwards fault)',
        CUSTOMER_FAULT: '客户引起的故障',
        OTHER: '其他',
        AGREE_WITH_TECHNICAL_WARRANTY_LOG: '同意技术判定',
        DISAGREE_WITH_TECHNICAL_WARRANTY_LOG: '不同意技术判定',
        SPARE_PART: 'Spare part (Service Division) ZH',
      },
      CommercialWarranty: {
        CONTRACTUAL_AGREEMENT: '合同协议',
        GOODWILL_ACCEPTED: '接受Goodwill',
        CHARGEABLE_TO_CUSTOMER: '向客户收取费用',
        EXTENDED_WARRANTY: '延长保修合同',
        SERVICE_CONTRACT: '服务合同',
        OTHER: '其他',
        SEMICONDUCTOR: 'SEMI',
        SCIENTIFIC: 'SV',
        INDUSTRIAL: 'IV',
        SEMICONDUCTOR_SERVICE: 'VSS',
        VACUUM_TECHNIQUE_SERVICE: 'VTS',
        SEMICONDUCTOR_CHAMBER_SOLUTIONS: 'CS',
        SEMI_ABATEMENT_AND_INTEGRATED_SYSTEMS: 'Semi Abatement & integrated systems',
        SEMI_ADVANCED_CHEMICAL_MANAGEMENT: 'Semi Advanced Chemical Management',
        SERVICE_CRYOGENICS: 'Service Cryogenics',
        SEMI_DRY_PUMPS: 'Semi Dry Pumps',
        INDUSTRIAL_CUSTOM_DESIGN: 'Industrial custom design',
        INDUSTRIAL_VACUUM: 'Industrial Vacuum',
        SCIENTIFIC_CUSTOM_DESIGN: 'Scientific custom design',
        SEMICON_TURBO_PUMPS: 'Semicon Turbo pumps',
        POLYCOLD: 'Polycold',
      },
      Release: {
        NO_TECHNICAL_TEAM_INVOLVEMENT: '无需技术团队参与',
        GOLDENEYE_UPLINK: 'GoldenEye',
        ON_SITE_PRESENCE: '现场参与',
        RETURN_TO_PRODUCT_COMPANY: '退回PC',
        SEND_BACK_PARTS: '发回零件',
      },
      Forms: {
        fields: {
          basicInformation: '基本信息',
          customerCenter: '客户中心',
          serviceTechnologyCenter: 'STC',
          reportLevel: '报告等级',
          initialWarrantyCode: '初始保修代码',
          technicalDecision: '技术判定',
          commercialDecision: '商务判定',
          price: '价格',
          jobStatus: '工单状态',
          reportCompletion: '报告完成',
          alerts: '提醒',
          team: '团队成员',
          customer: '客户',
          customerContact: '客户联系人',
          jobDetails: '工单详情',
          jobType: '工单类型',
          serviceProduct: '服务产品',
          equipment: '设备',
          failure: '故障',
          symptom: '故障症状',
          address: '地址',
          contactPerson: '联系人',
          email: '电子邮件',
          phone: '电话',
          customerPurchaseOrderNumber: '客户订单号',
          equipmentWarranty: '产品保修',
          serviceWarranty: '维修保修',
          reportStatus: '报告状态',
          reopen: '重新打开',
          releaseJob: '发布工单',
          notifyTeam: 'Notify team ZH',
        },
        errors: {
          required: '必填字段',
          tel: '请输入有效电话号码。',
          email: '请输入有效电子邮件。',
          number: '只允许输入数字',
          alphanumeric: '不允许特殊字符',
          text: '请输入一个有效值',
          unknown: '发生错误',
          belowZero: '输入值不能小于0 0.',
          uploadFailed: '无法上传',
          maxFileSize: '最大附件大小为',
          maxLength: maxLength => `Max ${maxLength} characters allowed`,
          minLength: minLength => `Please enter at least ${minLength} characters`,
        },
      },
      FaultCodes: {
        fallbackDescription: '该编码无描述',
        jobTypeDescription: {
          'JT001': '工单类型JT001描述 JT001',
          'JT002': '工单类型JT002描述 JT002',
        },
        faultCodeDescription: {
          'FC001': '故障代码FC001描述 FC001',
          'FC002': '故障代码FC002描述 FC002',
        },
        symptomCodeDescription: {
          'SC001': '症状代码SC001描述 SC001',
          'SC002': '症状代码SC001描述 FC002',
        },
      },
      Progress: {
        title: '进展',
        productReceived: '收货',
        productEvaluation: '产品评估',
        stripObservation: '拆解观察',
        technicalInvestigation: '技术调查',
        conformityTest: '一致性测试',
      },
    },
    Profile: {
      title: '概述',
      name: '姓名',
      role: '职务',
      company: '公司',
      rights: '权限',
      linked: '用户关联于',
    },
    Jobs: {
      title: '工单',
      filters: '筛选',
      myJobs: '我的工单',
      otherJobs: '其他工单',
      noJobsToDisplay: '无可显示工单',
      pleaseUseTheSearchBar: "Please use the search bar. ZH",
      id: 'ID',
      createdAt: '创建日期',
      status: '状态',
      customer: '客户',
      serialProductNumber: '服务产品号',
      materialNumber: '物料号',
      equipmentSerialNumber: '产品序列号',
      customerCenterPlantCode: '客户中心代码',
      serviceTechnologyCenterPlannerGroup: 'STC计划组',
      handledBy: '处理者',
      reportLevel: '报告等级',
      materialDescription: '材料说明',
      customerName: '客户名称',
      receivedDate: '收货日期',
      customerCenterName: '抄送人',
      serviceOrderNumber: '服务订单号',
      workFlow: '工作流程',
      analysisFlow: '分析流程',
      productReceived: '收货',
      productEvaluation: '产品评估',
      stripObservation: '拆解观察',
      technicalInvestigation: '技术调查',
      conformityTest: '一致性测试',
      notificationNumber: '通告号',
    },
    Job: {
      editButton: '编辑',
      progress: '进展',
    },
    Filters: {
      filtersTitle: '筛选',
      applyButton: '应用',
      clearButton: '清除',
      sorting: '排序',
      sortNew: '排序从新到旧',
      sortOld: '排序从旧到新',
      date: '日期',
      dateFrom: '从',
      dateTo: '至',
      reportLevel: '报告等级',
      status: '状态',
      customerNumber: '客户号',
      customerName: '客户姓名',
      serviceProductNumber: '服务产品号',
      materialNumber: '物料号',
      equipmentSerialNumber: '设备序列号',
      stcPlannerGroup: 'STC计划组',
      selectstcPlannerGroup: '选择STC计划组',
      CCplant: '客户中心',
      selectCCplant: '选择CC工厂',
      distributor: '发行人',
      selectDistributor: '选择分销商',
      failureAnalysisEngineerNotAssigned: '未指派故障分析工程师',
      openedJobs: '职位空缺',
      publishedJobs: '已发布的职位',
      unreadMessages: '未读信息',
      pendingMyApproval: '等待我的批准',
      notificationNumber: '通告号',
      serviceOrderNumber: '服务订单号',
    },
    AddJob: {
      formSections: {
        title: '新增工单',
        createdAt: '创建日期',
        button: '保存',
        basicInformation: {
          title: '基本信息',
          fieldLabels: {
            equipmentSerialNumber: '设备序列号',
            serviceTechnologyCenter: 'STC',
            customerCenter: '客户中心',
            reportLevel: '报告等级',
            initialWarrantyCode: '初始保修代码',
            customerPurchaseOrderNumber: '客户订单号',
            responsibleSalesPerson: '负责销售人员',
            customerCenterContactName: '客户中心联系人姓名',
            customerCenterContactEmail: '客户中心联系电子邮件',
          },
        },
        jobType: {
          title: '类型',
          fieldLabels: {
            jobType: '类型',
            jobTypeDescription: '描述',
          },
        },
        searchMaterialNumber: '搜索物料号',
        materialNumber: {
          title: '物料号',
          fieldLabels: {
            materialNumber: '物料号',
            materialNumberDescription: '描述',
          },
        },
        serviceProductNumber: {
          title: '服务产品号',
          fieldLabels: {
            serviceProductNumber: '服务产品号',
            serviceProductNumberDescription: '描述',
          },
        },
        symptomCode: {
          title: '故障症状代码',
          fieldLabels: {
            scGroups: '故障症状代码组',
            symptomCode: '故障症状代码',
            symptomCodeDescription: '故障症状描述',
          },
        },
        faultCode: {
          title: '故障代码',
          fieldLabels: {
            fcGroups: '故障代码组',
            faultCode: '故障代码',
            faultCodeDescription: '故障描述',
          },
        },
        customerInformation: {
          title: '客户信息',
          fieldLabels: {
            customerId: '客户ID',
            customerName: '名称',
            customerAddress: '地址',
            customerContact: '联系人',
            customerEmail: '电子邮件地址',
            customerPhone: '电话号码',
          },
        },
      },
    },
    ImportJob: {
      title: '导入工单',
      date: '导入日期',
      importButton: '导入',
      searchTitle: '搜索导入工单',
      searchSubtitle: '至少输入5个数字，首位数字非零',
      searchButton: '搜索',
      notificationNumberLabel: '通告号',
      serviceOrderNumberLabel: '服务订单号',
      linkTo: '链接到',
      openJobsFoundForSerNumber: '打开该序列号找到的工单',
      importJobAsNew: '导入新工单',
      jobIsImportedAlready: '工单已导入',
      importing: 'Importing in progress... ZH',
      linking: 'Linking in progress... ZH',
      columns: {
        sourceId: '品牌',
        notificationNumber: '通告号',
        serviceOrderNumber: '服务订单号',
        serialNumber: '序列号',
        jobTypeDescription: '描述',
        customerName: '客户名称',
      },
    },
    SingleJob: {
      title: '工单',
      createdAt: '创建时间',
      modifiedAt: '最后更改时间',
      serviceOrderNumber: '服务订单号',
      notificationNumber: '通告号',
      receivedProduct: '收货',
      productEvaluation: '产品评估',
      stripObservation: '拆解观察',
      technicalInvestigation: '技术调查',
      conformityTest: '一致性测试',
      log: '日志',
      conversation: '会话',
      noTechPossibilityParagraph1: '该STC对此工单无维修能力。',
      noTechPossibilityParagraph2: '请关闭工单，并把该设备发送到另一个STC。',
      downloadPictures: '下载图片',
      downloadAllPictures: '下载所有图片', 
      downloadPicturesFrom: '从下载图片',
      downloadInProgressPleaseWait: 'Download in progress... Please wait ZH',
    },
    JobSummary: {
      title: '工单概况',
      createdAt: '创建日期',
      modifiedAt: '最后更改日期',
      reportLevelDialogTitle: '报告等级',
      reportLevelDialogContent: '设置报告等级',
      reportLevelDialogInitialWarrantyCodeLabel: '初始保修代码',
      approveReportLevelDialogTitle: '批准报告等级变更请求',
      technicalWarrantyDialogTitle: '建议保修判定',
      editTechnicalWarrantyDialogTitle: 'Edit technical decision proposal ZH',
      rateTechnicalDecisionTitle: '评价技术判定',
      rate: '评级',
      reclassify: 'Reclassify ZH',
      technicalWarrantyDialogContent: '保修判定',
      technicalWarrantyDialogCategory: '保修类别',
      technicalWarrantyDialogSIBFieldLabel: 'SIB',
      approveTechnicalWarrantyDialogTitle: '批准技术保修决定建议',
      approveTechnicalWarrantyDialogSIBLabel: 'SIB',
      reclassifyTechnicalWarrantyDialogTitle: '重新决定保修判定类别',
      commercialDecisionDialogTitle: '商务判定建议',
      commercialDecisionDialogContent: '保修判定',
      commercialDecisionDialogCategory: '保修类别',
      approveCommercialDecisionDialogTitle: '批准建议',
      amendTechnicalWarrantyDecisionDialogTitle: 'Amend technical warranty decision ZH',
      amendCommercialDecisionDialogTitle: 'Amend commercial decision ZH',
      editPriceDialogTitle: '修改价格',
      editPriceLabel: '编辑',
      proposedDate: '拟定日期',
      releaseJobDialogTitle: '发布工单',
      chooseReleaseJobMethodTitle: '选择发布工单模式',
      editChosenReleaseJobMethodTitle: '修改发布工单模式',
      releaseJobDialogLabel: 'Select method',
      reportStatusDialogTitle: '建议报告状态',
      reportStatusDialogContent: '这将会产生一个报告审批请求',
      approveReportStatusDialogContent: '你确定要重新打开这个工单吗？',
      approveReportStatusDialogTitle: '报告状态',
      editJobStatusDialogTitle: '编辑工单状态',
      editEquipmentSerialNumberDialogTitle: '编辑设备序列号',
      editEquipmentSerialNumberDialogFieldLabel: '设备序列号',
      editMaterialNumberDialogTitle: '编辑物料号',
      editMaterialNumberDialogFieldLabel: '物料号',
      editMaterialNumberDialogDescriptionFieldLabel: '描述',
      warrantyStartDialogTitle: '编辑保修起始日期',
      warrantyStartDateLabel: '保修起始日期',
      warrantyEndDialogTitle: '编辑保修截止日期',
      warrantyEndDateLabel: '保修截止日期',
      verifyJobDialogTitle: '核实工单信息',
      verifyJobDialogContent: '物料号和设备序列号将无法再更改。你确定以下信息正确吗？',
      materialNumber: '物料编号',
      equipmentSerialNumber: '设备序列号',
      deleteConfirmationDialogTitle: '需要确认',
      deleteConfirmationDialogContent: '你确定要删除该工单？',
      teamDialogTitle: '添加团队成员',
      removeTeamMemberDialogTitle: '删除团队成员',
      removeTeamMemberDialogContent: '你确定要删除该成员吗？',
      technicalDecisionReason: '保修判定理由',
      warrantyExpiredSubcategoryLabel: 'Out of standard warranty period - Warranty subcategory',
      changeReportLevelReason: '变更报告等级的理由',
      rateTechnicalDecisionComment: '点评技术判定',
      decisionReason: '判定理由',
      commercialDecisionReason: '商务判定理由',
      approveReportLevelDialogRequestedLevel: '要求等级',
      approveReportLevelDialogPreviousLevel: '上一级',
      approveReportLevelDialogInitialWarrantyCode: '初始保修代码',
      initialWarrantyCode: '初始保修代码',
      shipToAddress: '送货地址',
      partNumbers: '料号',
      failureReason: '失效原因',
      symptomReason: '症状原因',
      chooseMethod: '选择模式',
      chosenMethod: '选择模式',
      serialNumberMissingPleaseAdd: 'Serial number missing, please add. ZH',
      deleteImportedJob: 'Delete imported ZH',
      deleteImportedJobConfirmationDialogContent: 'Are you sure that you want to fully delete this imported job? ZH',
    },
    LogSection: {
      title: '日志',
      sib: 'SIB',
      initialWarrantyCode: '初始保修代码',
    },
    ReportsDialog: {
      title: '生成报告',
      confirmButton: '生成',
      reportFormat: '报告格式',
      reportTemplate: '报告模板',
    },
    ActionMode: {
      takePicture: '拍照',
      takeStandardPicture: '拍摄标准照片',
      takeNonStandardPicture: '拍摄额外照片',
      lastScreenMessage: '你已经到了本节的结尾，请关闭本窗口',
      lastScreenMessageUnsavedAnswers: '您已经到了本节的结尾。 请保存',
    },
    InputFile: {
      special: '特别',
      upload: '上传',
      uploadStandardPicture: '上传标准照片',
      uploadNonStandardPicture: '上传额外照片',
      commentPicture: '评论图片',
      confirmButtonText: '保存评论',
      moveFileModal: {
        title: '移动文件',
        confirmButtonText: '移动',
        selectSubsection: '选择小节',
        selectQuestion: '选择问题',
      },
    },
    FilePreviewModal: {
      moveFileButtonText: '移动',
    },
  }
  


// WEBPACK FOOTER //
// ./src/constants/translations/zh.js